import {Injectable} from '@angular/core';
import {Effect, Actions} from '@ngrx/effects';
import * as storeAction from '../actions/settings.action';
import {map, switchMap, mergeMap} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {Action, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import * as fromStore from '../../../store';
import {SettingsService} from '../../settings.service';


@Injectable()
export class SettingsEffect {
  constructor(private actions: Actions, private storeService: SettingsService, private store: Store<fromStore.AppState>) {
  }

  @Effect()
  getStoreTimings: Observable<Action> = this.actions.ofType(storeAction.GET_STORE_TIMINGS)
    .map((action: storeAction.GetStoreTimings) => action.payload)
    .pipe(
      mergeMap(body => {
        return this.storeService.getStoreTimings(body)
          .map(res => new storeAction.GetStoreTimingsSuccess(res))
          .catch(error => of(new storeAction.GetStoreTimingsError(error)));
      })
  );

  @Effect()
  addTiming: Observable<Action> = this.actions.ofType(storeAction.ADD_NEW_TIMING)
    .map((action: storeAction.AddNewTiming) => action.payload)
    .pipe(
      mergeMap(body => {
        return this.storeService.addNewTiming(body)
          .map(res => new storeAction.AddNewTimingSuccess(res))
          .catch(error => of(new storeAction.AddNewTimingError(error)));
      })
    );

  @Effect()
  getStoreDetails: Observable<Action> = this.actions.ofType(storeAction.GET_STORE_DETAILS)
    .map((action: storeAction.GetStoreDetails) => action.payload)
    .pipe(
      mergeMap(body => {
        return this.storeService.getStoreDetails(body)
          .map(res => new storeAction.GetStoreDetailsSuccess(res))
          .catch(error => of(new storeAction.GetStoreDetailsError(error)));
      })
  );

  @Effect()
  updatepopupStoreTimings: Observable<Action> = this.actions.ofType(storeAction.UPDATE_STORE_TIMINGS)
    .map((action: storeAction.UpdateStoreTimings) => action.payload)
    .pipe(
      mergeMap(body => {
        return this.storeService.updateStoreTimings(body)
          .map(res => new storeAction.UpdateStoreTimingsSuccess(res))
          .catch(error => of(new storeAction.UpdateStoreTimingsError(error)));
      })
  );

    @Effect()
    updateStoreDetails: Observable<Action> = this.actions.ofType(storeAction.UPDATE_STORE_DETAILS)
      .map((action: storeAction.UpdateStoreDetails) => action.payload)
      .pipe(
        mergeMap(body => {
          return this.storeService.updateStoreDetails(body)
            .map(res => new storeAction.UpdateStoreDetailsSuccess(res))
            .catch(error => of(new storeAction.UpdateStoreDetailsError(error)));
        })
    );
  

}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/settings/store/effects/settings.effect.ts